import React from 'react'
import notFound from '../images/404.jpg'
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';


export default function Not_found_404() {
    return (
        <Container maxWidth="md">
            <Box sx={{
                mt: { xs: '70px', sm: '75px', md: '61px' },
                mb: { xs: 4, sm: 6, md: 8 },
                px: { xs: 2, sm: 3, md: 0 },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                minHeight: 'calc(100vh - 200px)'
            }}>
                <Box sx={{ mb: { xs: 3, sm: 4, md: 5 } }}>
                    <Typography
                        variant="h3"
                        component="h1"
                        sx={{
                            fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' },
                            fontWeight: 'bold',
                            mb: 2,
                            color: 'primary.main'
                        }}
                    >
                        Page Not Found
                    </Typography>

                    <Typography
                        variant="h6"
                        component="p"
                        sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
                            lineHeight: 1.6,
                            mb: 1,
                            color: 'text.secondary'
                        }}
                    >
                        It's not the end of the world as we know it,
                    </Typography>

                    <Typography
                        variant="h6"
                        component="p"
                        sx={{
                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
                            lineHeight: 1.6,
                            mb: 3,
                            color: 'text.secondary'
                        }}
                    >
                        just a page not found.
                    </Typography>

                    <Button
                        component={RouterLink}
                        to="/"
                        variant="contained"
                        size="large"
                        startIcon={<HomeIcon />}
                        sx={{
                            py: { xs: 1.5, sm: 2 },
                            px: { xs: 3, sm: 4 },
                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                            fontWeight: 'bold',
                            borderRadius: 2,
                            textTransform: 'none',
                            mb: { xs: 3, sm: 4 }
                        }}
                    >
                        Go Home
                    </Button>
                </Box>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                    maxWidth: { xs: '280px', sm: '350px', md: '400px' }
                }}>
                    <img
                        src={notFound}
                        alt="404 - Page not found"
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxWidth: '400px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                        }}
                    />
                </Box>
            </Box>
        </Container>
    )
}